import axiosInstance from '../../../api/AxiosInstance';
import { endpoints } from '../../../services/endpoints';
import { deleteMenuRequest, deleteMenuRequestError, deleteMenuRequestSuccess } from '../../slices/Menu/DeleteMenuSlice';


export const DeleteMenuAPI = (id) => {
    const url = `${endpoints.deleteMenu}/${id}`;
    return async (dispatch) => {
        try {
            dispatch(deleteMenuRequest());
            // Returning the promise so we can await it in handleSubmit
            const response = await axiosInstance({
                method: "DELETE",
                url: url,
            })
            return dispatch(deleteMenuRequestSuccess(response?.data));
        } catch (error) {
            const _error = {
                data: error?.response?.data?.message || error?.message,
                status: error?.response?.status || error?.status,
            };
            return dispatch(deleteMenuRequestError(_error));
        }
    };
};
